import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";

// Private picture (needs the sign-in token), e.g. a test-paper question figure
export default function AuthImg({ src, alt = "", className = "", testId }) {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let u = null;
    setUrl(null);
    setFailed(false);
    api.get(src, { responseType: "blob" }).then(({ data }) => { u = URL.createObjectURL(data); setUrl(u); }).catch(() => setFailed(true));
    return () => { if (u) URL.revokeObjectURL(u); };
  }, [src]);
  if (failed) return null;
  if (!url) return <Loader2 className="animate-spin text-slate-400 m-4" size={22} />;
  return <img src={url} alt={alt} className={className} data-testid={testId} draggable={false} />;
}

export async function downloadPdf(path, fallbackName) {
  const res = await api.get(path, { responseType: "blob" });
  const cd = res.headers["content-disposition"] || "";
  const star = /filename\*=UTF-8''([^;]+)/i.exec(cd);
  const m = /filename="([^"]+)"/.exec(cd);
  const u = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = u;
  a.download = star ? decodeURIComponent(star[1]) : m ? m[1] : fallbackName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(u), 30000);
}

export async function openPdf(path) {
  const w = window.open("", "_blank");
  const { data } = await api.get(path, { responseType: "blob" });
  const u = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
  if (w) w.location.href = u; else window.location.href = u;
}
